export default {
    cidade:{ "nome": "Todas as Cidades", "codigo": 0, "estado": ""},
    cartao: '0'
}